import { Navigate, Outlet } from 'react-router-dom';
import { isLogin } from '../../utils/common';

export default function PrivateRoute() {
  return isLogin ? <Outlet /> : <Navigate to="/login" />;
}
